(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const TEXT = [
    '.vn-head',
    '.vn-showcase__header',
    '.vn-room__header',
    '.vn-materials__header',
    '.vn-journal__header',
    '.vn-tiles__header',
    '.vn-intro__copy',
    '.vn-it__copy',
    '.vn-feature__info',
    '.vn-story__content',
    '.vn-faq__intro',
    '.vn-news__body',
    '.vn-contact__info',
    '.vn-quote__body',
    '.vn-promo__inner',
    '.title-wrapper-with-link',
    '.collection-hero__text-wrapper',
    '.rich-text__blocks',
    '.vn-page__header',
    '.vn-blog__header',
    '.vn-article__header',
    '.vn-collections__title',
    '.vn-cp__intro',
    '.vn-cp__panel',
    '.vn-404',
  ];
  const ITEMS = [
    '.vn-showcase__item',
    '.vn-pgrid__item',
    '.vn-pgrid__promo',
    '.vn-tile',
    '.vn-material',
    '.vn-journal__article',
    '.vn-gallery__item',
    '.vn-review',
    '.vn-stat',
    '.vn-step',
    '.vn-usp__item',
    '.vn-faq__item',
    '.vn-room__list-item',
    '.vn-logos__item',
    '#product-grid > .grid__item',
    '.related-products .grid__item',
    '.vn-post',
    '.vn-collections__item',
    '.vn-cp-location',
    '.template-search__results .grid__item',
  ];
  const MEDIA = [
    '.vn-intro__frame',
    '.vn-it__main',
    '.vn-feature__main',
    '.vn-story__image-wrapper',
    '.vn-news__media',
    '.vn-contact__media',
    '.vn-quote__media',
    '.vn-room__media',
    '.vn-gallery__frame',
  ];

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-inview');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
  );

  const tag = (el, type, top, delay = 0) => {
    if (el.dataset.vnReveal || top <= window.innerHeight * 0.92) return;
    el.dataset.vnReveal = type;
    if (delay) el.style.setProperty('--vn-delay', `${delay}ms`);
    observer.observe(el);
  };

  const setup = () => {
    const main = document.querySelector('main') || document.body;
    const measure = (selector, type) =>
      [...main.querySelectorAll(selector)].map((el) => {
        const rect = el.getBoundingClientRect();
        return { el, type, top: rect.top, left: rect.left, parent: el.parentElement };
      });
    const texts = measure(TEXT.join(','), 'text');
    const media = measure(MEDIA.join(','), 'media');
    const items = measure(ITEMS.join(','), 'item');

    texts.concat(media).forEach(({ el, type, top }) => tag(el, type, top));

    const rows = new Map();
    items.forEach((item) => {
      const key = Math.round(item.top / 8);
      if (!rows.has(item.parent)) rows.set(item.parent, new Map());
      const parentRows = rows.get(item.parent);
      if (!parentRows.has(key)) parentRows.set(key, []);
      parentRows.get(key).push(item);
    });
    rows.forEach((parentRows) =>
      parentRows.forEach((row) =>
        row
          .sort((a, b) => a.left - b.left)
          .forEach((item, i) => tag(item.el, 'item', item.top, Math.min(i, 5) * 90))
      )
    );
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(setup, { timeout: 600 });
  } else {
    setTimeout(setup, 200);
  }
})();
